"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonService = exports.commonServiceMap = void 0;
var typedi_1 = require("typedi");
var DecoratorMetadataStorage_1 = require("./DecoratorMetadataStorage");
exports.commonServiceMap = new Map();
function CommonService(alias, options) {
    if (options && options.replaceAngularService) {
        if (!Array.isArray(options.replaceAngularService)) {
            options.replaceAngularService = [options.replaceAngularService];
        }
    }
    return function (constructor) {
        constructor.__alias = alias;
        (0, DecoratorMetadataStorage_1.getDecoratorMetadataStorage)().setCommonService(alias, { alias: alias, options: options });
        if ((options === null || options === void 0 ? void 0 : options.override) && !exports.commonServiceMap.get(alias)) {
            throw new Error('You are trying to override a service that does not exist. Please ensure that the overridden service is imported after');
        }
        if (exports.commonServiceMap.get(alias)) {
            // check for override
            if (!(options === null || options === void 0 ? void 0 : options.override)) {
                throw new Error("Duplicate service detected ".concat(alias, " but no 'override' was set on the CommonService decorator"));
            }
        }
        exports.commonServiceMap.set(alias, constructor);
        (0, typedi_1.Service)()(constructor);
        if ((options === null || options === void 0 ? void 0 : options.alwaysInitialized) === true) {
            typedi_1.Container.get(constructor);
        }
    };
}
exports.CommonService = CommonService;
//# sourceMappingURL=CommonService.decorator.js.map